/* Lumeris : ajout en 1 clic depuis le panier (suggestion), sans quitter le panier */
(function(){
  if(window.lmCartInit)return;window.lmCartInit=true;
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-lm-add]');
    if(!b)return;
    e.preventDefault();
    if(b.disabled)return;
    b.disabled=true;b.classList.add('is-loading');var lbl=b.textContent;b.textContent='Ajout…';
    var drawer=document.querySelector('cart-drawer');
    fetch((window.routes&&window.routes.cart_add_url?window.routes.cart_add_url:'/cart/add')+'.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(b.getAttribute('data-lm-add')),quantity:1}],sections:'cart-drawer,cart-icon-bubble',sections_url:window.location.pathname})
    }).then(function(r){return r.json();}).then(function(s){
      if(s&&s.sections&&drawer&&drawer.renderContents){drawer.renderContents(s);}
      else{window.location.href='/cart';}
    }).catch(function(){window.location.href='/cart';})
    .finally(function(){b.disabled=false;b.classList.remove('is-loading');b.textContent=lbl;});
  });
})();
